<template>
	<div :class="['py-300 py-500-md', data.isSectionDarkTheme ? 'bg-color-content-primary' : 'bg-color-white']">
		<MarketingPageHeader :header="header" :theme="theme"></MarketingPageHeader>
		<div class="container">
			<InfoCardsInverted
				:cards="infoCards"
				:card-heading-style="cardStyles"
				:theme="theme"
				:use-full-img-url="true"
				:hide-border="true"
			/>
		</div>
	</div>
</template>
<script setup lang="ts">
import { InfoCard, LandingPageHeader } from 'types/layout';
import { computed } from 'vue';
import InfoCardsInverted from '@components/layout/info-cards-inverted.vue';
import MarketingPageHeader from '@components/marketing-site/marketing-page-header.vue';
import { SanityInfoCardsSection } from 'types/sanity/marketing-components';

interface Props {
	data: SanityInfoCardsSection;
}
const props = defineProps<Props>();

const theme = computed((): 'light' | 'dark' | undefined => {
	return props.data.isSectionDarkTheme ? 'dark' : 'light';
});

const cardStyles = computed((): Array<string> => {
	const styles = ['heading-1'];
	if (theme.value === 'dark') {
		styles.push('text-color-greige');
	}
	return styles;
});

const header = computed((): LandingPageHeader => {
	return {
		title: props.data.panelOverline,
		heading: props.data.panelHeading,
		summary: [props.data.sectionSummary]
	};
});

const infoCards = computed((): Array<InfoCard> => {
	return props.data.sectionCards.map((card) => ({
		imageUrl: card.image?.asset.url ?? '',
		imageAlt: card.image?.asset.altText ?? '',
		heading: card.heading ?? '',
		title: card.title ?? '',
		description: [card?.description ?? ''],
		link:
			card.link?.url && card.link?.linkText
				? {
						text: card.link.linkText,
						href: card.link.url,
						target: card.link.openInNewTab ? '_blank' : '_self'
					}
				: undefined
	}));
});
</script>
